import React, { useState, useEffect } from 'react'
import Box from '@material-ui/core/Box'
import CircularProgress from '@material-ui/core/CircularProgress'
import { getUserSession } from '../../lib/auth-api'

const CurrentUserDisplay = ({ children, fallback }) => {
  const [isLoading, setIsLoading] = useState(true)
  const [currentUser, setCurrentUser] = useState(null)

  useEffect(() => {
    const loadUser = async () => {
      const user = await getUserSession()
      setCurrentUser(user)
    }
    loadUser()
  }, [])

  // Automatically clear the loading spinner after 1 second
  // to prevent a jarring page load.
  // The user session should be loaded by then (~250ms).
  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false)
    }, 1000)
    return () => clearTimeout(timer)
  }, [])

  if (isLoading) {
    return (
      <Box display="flex" justifyContent="center">
        <CircularProgress color="primary" />
      </Box>
    )
  }

  if (currentUser) {
    return children({ currentUser })
  } else {
    return fallback
  }
}

export default CurrentUserDisplay
